import { ITreeLeaf, ITreePluginsProps, ITreeStylingParams } from '../../tree.types'
import { memo } from 'react'
import cn from '../../../../utils/cn'

interface IProps<Leaf extends Record<string, any>, GroupId extends string | number>
  extends Pick<ITreePluginsProps, 'selectCtrl'> {
  onClickLeaf?: (leaf: Leaf) => void
  leaf: ITreeLeaf<Leaf, GroupId>
  leafRenderer: (leaf: ITreeLeaf<Leaf, GroupId>) => JSX.Element | string
  styling?: ITreeStylingParams
}

const TreeLeafNode = <Leaf extends Record<string, any>, GroupId extends string | number>(
  props: IProps<Leaf, GroupId>
) => {
  const leafContentClassName = cn('inline-flex-gap', props.styling?.leafClassname)
  const leafContentCustomStyles = props.styling?.leafStyles ?? {}

  const handleClickLeaf = () => {
    if (props.selectCtrl) {
      props.selectCtrl.handleSelect(props.leaf.key)
    }
    if (props.onClickLeaf) {
      props.onClickLeaf(props.leaf.data)
    }
  }

  return (
    <div
      data-selected={props.selectCtrl && props.leaf.key === props.selectCtrl.selectedItem}
      className={leafContentClassName}
      style={leafContentCustomStyles}
      onClick={handleClickLeaf}
    >
      {props.leafRenderer(props.leaf)}
    </div>
  )
}

export default memo(TreeLeafNode)
